export default __webpack_public_path__ + "static/media/Custom-HUD-Dock Icons (5 Icons).38efbe1f.jpg";